import countryCodes from "components/dashboard/countryISOCodes.json";
import ReactCountryFlag from "react-country-flag";
import { COUNTRY_NAME_ALIASES } from "utils/countryNameAliases";

type FlagProps = {
	country?: string;
	className?: string;
	width?: number | string;
	height?: number | string;
	rounded?: boolean;
	alt?: string;
};

const Flag: React.FC<FlagProps> = ({ country, className = "", width = 21, height = 14, rounded = false, alt = "" }) => {
	// Some sources (e.g. Nuitee hotel details) return an ISO alpha-2 code directly ("VN") rather
	// than a full country name — the name-based lookup below only matches full names, so resolve
	// alpha-2 codes against that field instead of silently failing to find a flag.
	let alpha2: string | undefined;
	if (country && country.length === 2) {
		alpha2 = countryCodes.find((countryFromList) => countryFromList.alpha2?.toUpperCase() === country.toUpperCase())?.alpha2;
	} else {
		// Handle country name variations (LocationIQ/API may return "United States of America" or "USA" but we store "United States")
		const normalizedCountry = country ? (COUNTRY_NAME_ALIASES[country] ?? country) : country;
		alpha2 = countryCodes.find((countryFromList) => countryFromList.country === normalizedCountry)?.alpha2;
	}
	return (
		<div className={`flag ${className}`.trim()}>
			{/* `ReactCountryFlag` spreads its `ImgProps` straight onto the rendered `<img>`, so
			    passing nothing here means no `alt` attribute at all — not even `alt=""` — which
			    leaves a screen reader to fall back to the flag's filename or URL. `alt=""` is the
			    correct default: every call site renders this flag directly beside the country or
			    language name in text (see `LanguageSwitcher`, `CountryCard`), so the flag is
			    decorative and a descriptive alt would just make a screen reader announce the same
			    name twice. */}
			<ReactCountryFlag
				svg
				countryCode={alpha2}
				alt={alt}
				style={{ width, height, borderRadius: rounded ? "50%" : "2px", display: "block", objectFit: "cover", border: 0 }}
			/>
		</div>
	);
};

export default Flag;
